/*========================================================================
* $Id: list.js 124298 2018-01-15 14:43:10Z erhard.einsiedler $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore", "utils/string"], function (_, StringUtils) {
  var MERGE_STRATEGIES = {
    OVERRIDE: '=',
    MERGE: '+=',
    ASSIGN_IF_NOT_SET: '||='
  }
  
  function SettingsConfig(config) {
    this.config = config || {};
  }
  
  _.extend(SettingsConfig.prototype, {
    getEffectiveSettingsForTemplate: function (templateName, attributeSettings) {
      if (this.config) {
        var configKeys = _.keys(this.config);
        var applicationAttributeSettings = configKeys.filter(function(key) { return key.startsWith(templateName) + '.'});
        if (applicationAttributeSettings.length) {
          var finalAttrs = this.mergeAttributes(templateName, attributeSettings);

          return finalAttrs;
        }
      }

      return attributeSettings;
    },

    mergeAttributes: function (templateName, templateAttributeSettings) {
      var finalAttributes = _.extend(templateAttributeSettings, {});
      
      var that = this;
      _.each(_.keys(this.config), function(key) {
        var settingTemplateName = key.split('.')[0];
        var settingAttributeName = key.split('.')[1];

        if (settingTemplateName !== templateName) {
          return;
        }

        if (settingAttributeName === 'constraint') {
          var constraintValue = that.getMergedConstraint(that.getConfigProperty(templateName, settingAttributeName), templateAttributeSettings[settingAttributeName]);
          finalAttributes[settingAttributeName] = constraintValue;
        } else {
          if (that.containsCongfigProperty(templateName, settingAttributeName)) {
            finalAttributes[settingAttributeName] = that.getConfigProperty(templateName, settingAttributeName);
          } else {
            finalAttributes[settingAttributeName] = templateAttributeSettings[settingAttributeName];
          }
        }
      });
      
      return finalAttributes;
    },

    getConfigProperty: function(templateName, attributeName) {
      return this.config[templateName + '.' + attributeName];
    },

    containsCongfigProperty: function(templateName, attributeName) {
      var key = templateName + '.' + attributeName;
      return (key in this.config);
    },

    getMergedConstraint: function(constraintInAppSettings, constraintInTemplateSettings) {
      // @todo handle 
      /*
        constraint: {
           path: "source_context.constraints.view_base",
           type: "QueryExpr",
           title: "editor_result_constraint",
           hiddenWithinSearchcontainerView: true
         },

      */
      if (_.isString(constraintInAppSettings)) {
        var originalConstraintStr = constraintInAppSettings;
        constraintInAppSettings = {};
        constraintInAppSettings[MERGE_STRATEGIES.ASSIGN_IF_NOT_SET] = originalConstraintStr;
      }
      
      var mergeStrategy = _.keys(constraintInAppSettings)[0];
      var mergeValue = _.values(constraintInAppSettings)[0];

      if (mergeStrategy === MERGE_STRATEGIES.OVERRIDE) {
        return mergeValue;
      } else if (mergeStrategy === MERGE_STRATEGIES.ASSIGN_IF_NOT_SET) {
        if (constraintInTemplateSettings === undefined) {
          return mergeValue;
        }
        
        return constraintInTemplateSettings;

      } else if (mergeStrategy === MERGE_STRATEGIES.MERGE) {
        if (constraintInTemplateSettings) {
          if (_.isString(mergeValue)) {
            mergeValue = {unparsed: mergeValue}
          }
          if (_.isString(constraintInTemplateSettings)) {
            constraintInTemplateSettings = {unparsed: constraintInTemplateSettings};
          }
          return {and:[constraintInTemplateSettings, mergeValue]}
        } else {
          return mergeValue;
        }
      } else {
        console.warn('Unknown merge strategy given for the settingsConfig constraint attribute');
        return constraintInTemplateSettings;
      }
    }
  });
 
  return SettingsConfig;
});
